import React from 'react';

import imageUrlBuilder from '@sanity/image-url';
import {sanityClient} from 'src/utils/sanity';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type IconContentProps = any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconContent: React.FC<IconContentProps> = (props: any) => {
  return (
    <div className="flex flex-wrap md:flex-nowrap mb-8" data-module="factoid">
      <div className="w-full md:w-2/12 max-w-[70px] md:mr-10">
        <img
          className="!m-0"
          src={imageUrlBuilder(sanityClient).image(props.icon.asset).url() || ''}
          alt={props.altText}
        />
      </div>
      <div className="w-full md:w-10/12 type-p mt-4 md:mt-0"> {props.content}</div>
    </div>
  );
};
